import { useState, useCallback } from 'react';
export const useHover = (initialState = false) => {
    const [isHovered, setIsHovered] = useState(initialState);
    const handleEnter = useCallback(() => setIsHovered(true), [setIsHovered]);
    const handleLeave = useCallback(() => setIsHovered(false), [setIsHovered]);
    return [isHovered, handleEnter, handleLeave];
};
//# sourceMappingURL=useHover.js.map